<template>
<p class="chart-sub">Percent of pre-pandemic transit service, in service hours, by mode.</p>
<ul class="mode-legend">
  <li v-for="item, index in chartSeries" v-bind:key="index">
    <div class="mode-legend-circle" :style='{ backgroundColor: chartColors[index] }'></div>
    {{ item.name }}
  </li>
</ul>
<apexcharts width="103%" height="272" type="area" :options="chartOptions" :series="chartSeries"></apexcharts>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import TransformMonthlyValues from '../util/transform-monthly-values.js'
import toPercentages from '../util/to-percentages.js'

export default {
  name: 'ServiceByModeChart',
  props: ['agency','baseMonths'],
  data() {
    return {
        startMonth: '2020-01-01',
        chartColors: ['#BF58BB','#47BEC6','#176087','#BE6E46','#E4B1AB']
    }
  },
  mounted() {

  },
  methods: {
    toPercentagesArrays: toPercentages.toPercentagesArrays
  },
  computed: {
    chartSeries(){ 
        var series = TransformMonthlyValues.arrayByModeForValue(this.agency.values,'vrh',this.startMonth).map((serie) => {
            serie.name = serie.mode

            serie.data = this.toPercentagesArrays(serie.data,this.baseMonths)

            delete serie.mode

            return serie
        })


        return series
    },
    chartOptions(){ return {
        chart: {
          id: 'mode-chart',
          stacked: false,
          offsetX: -14,
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false
          },
          selection: {
            enabled: false
          },
          zoom: {
            enabled: false
          },
          fontFamily: 'hero-new, sans-serif'
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          },
          labels: { style: {
            fontWeight: 700,
            cssClass: 'xaxis-labels'
          },
          hideOverlappingLabels: true }
        },
        yaxis: {
          min: 0,
          forceNiceScale: true,
          max: 1,
          labels: {
            formatter: (value) => {
              return Math.round(value * 100) + "%"
            }
          }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 3,
          colors: this.chartColors
        },
        fill: {
          type: 'none',
          opacity: 0,
          colors: this.chartColors
        },
        markers: {
          size: 0
        },
        legend: {
          show: false
        },
        colors: this.chartColors,
        // colors: [(value, seriesIndex, w) => {
        //   if(this.chartVariable == 'all'){ return '#20ABB5' } else {
        //     if(this.chartVariable == 'vrh'){ return '#20ABB5' } else {
        //       return '#BF58BB'
        //     }
        //   }
        // },'#BF58BB'],
        tooltip: {
          x: {
              show: true,
              format: 'MMM \'yy'
          },
          y: {
            formatter: (value) => {
              return Math.round(value * 100) + "%"
            }
          }
        },
        responsive: [{
          breakpoint: 600,
          options: {
              markers: {
                size: 0
              }
            }
          },
          {
            breakpoint: 400,
            options: {
              chart: {
                height: 180
              },
            }
          }
        ]
      }
      }
  },
  watch: {

  },
  components: {
    apexcharts: VueApexCharts
  }
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
</script>

<style>
.apexcharts-line-series.apexcharts-plot-series * {
  clip-path: none !important;
}

.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  font-weight: 900;
  background: none;
  border: none;
  padding: 0px 10px;
  line-height: 24px;
  display: block;
  height: 24px;
  margin-top: 6px;
  margin-bottom: 2px;
}

.apexcharts-tooltip.apexcharts-theme-light {
  border: 0;
  box-shadow: 0px 8px 20px rgba(0,0,0,0.2);
  background: white;
}

p.chart-sub {
  margin-top: 20px;
}

.mode-legend {
  display: block;
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.mode-legend li {
  display: inline-block;
  margin-right: 24px;
  height: 44px;
  line-height: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
  vertical-align: middle;
}

.mode-legend li div {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 3px;
  border-radius: 6px;
  vertical-align: middle;
  transform: translate3d(0,-1px,0);
}
</style>
